import { createSlice } from '@reduxjs/toolkit';

import { fetchProviderSummary } from './actions';

import type { ProviderSummaryState } from './types';

const initialState: ProviderSummaryState = {
  data: null,
  isFetching: false,
};

const providerSummarySlice = createSlice({
  name: 'providerSummary',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProviderSummary.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchProviderSummary.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchProviderSummary.rejected, (state, _action) => {
        state;
      });
  },
});

export const providerSummaryReducer = providerSummarySlice.reducer;
